module.exports = __webpack_public_path__ + "img/78.de5d0fc2.png";